import React, { useState } from "react";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { JWT } from "../../constants/local-storage";

export default function AdministrationBulkUpdater() {

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [file, setFile] = useState(null);

  const thisContainer = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingTop: '40px',
    height: "100vh",
    backgroundColor: 'white'
  };

  const contentStyle = {
    marginLeft: "220px",
    padding: "40px",
	marginTop:'0px'
  };

  const rowStyle = {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    padding: "20px",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    backgroundColor: "#fafafa"
  };

  const labelStyle = {
    fontWeight: "bold",
    minWidth: "250px"
  };

  const buttonStyle = {
    padding: "10px 16px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "13px",
  };

  const spinnerStyle = {
    width: "40px",
    height: "40px",
    border: "4px solid #eee",
    borderTop: "4px solid #007bff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginTop: "20px"
  };

  // ===============================
  // 📥 DOWNLOAD EXISTING
  // ===============================
  function handleDownload() {

    const token = localStorage.getItem(JWT);

    fetch("/resolutionsoftwareplatform/utilsapp/space-spreadsheet/download", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token
      }
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error("Download failed " + res.status);
        }
        return res.blob();
      })
      .then(function (blob) {

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "space-upload-template-data.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();

      })
      .catch(function (e) {
        console.error(e);
        setMessage("Download failed 😬");
      });
  }

  // ===============================
  // 📤 UPLOAD
  // ===============================
  async function handleUpload() {

    if (!file) {
      setMessage("Please select a file first.");
      return;
    }

    setLoading(true);
    setMessage(null);

    const formData = new FormData();
    formData.append("file", file);

    try {

      const response = await fetch("/resolutionsoftwareplatform/utilsapp/space-spreadsheet/upload", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem(JWT)
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error("Upload failed " + response.status);
      }

      const json = await response.json();

      setMessage(
        "Updated: " + json.updatedRows +
        " | Skipped: " + json.skippedRows +
        " | Total: " + json.totalRows
      );

    } catch (e) {
      console.error(e);
      setMessage("Upload failed 😬");
    }

    setLoading(false);
  }

  return (
    <div style={thisContainer}>

      <Header />
      <LeftMenu />

      <div style={contentStyle}>

        <h2 style={{ marginBottom: "20px" }}>
          Bulk Space Updater
        </h2>

        <div style={rowStyle}>

          <div style={labelStyle}>
            Space / Zones / Orgs / Capacity
          </div>

          <button
            onClick={handleDownload}
            style={buttonStyle}
          >
            Download Existing
          </button>

          <input
            type="file"
            accept=".csv"
            onChange={function (e) {
              setFile(e.target.files[0]);
            }}
          />

          <button
            onClick={handleUpload}
            style={buttonStyle}
            disabled={loading}
          >
            {loading ? "Uploading..." : "Upload"}
          </button>

        </div>

        {loading && <div style={spinnerStyle} />}

        {message && (
          <div style={{ marginTop: "20px", fontWeight: "bold" }}>
            {message}
          </div>
        )}

      </div>

      {/* Spinner animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

    </div>
  );
}